// extracted by mini-css-extract-plugin
export default {"tag":"ihwwX7DQ4wWqMIhbUMlP"};